import React from 'react';
import dayjs from 'dayjs';
import { formattedCardNumber } from 'suits-me-npm/utils';
import Button from 'components/shared/generic/button/presentational/Button';
import useTranslate from 'suits-me-npm/languages/useTranslate';

const FrozenCard = ({ position, onClick, info }) => {
    const cardNumber = formattedCardNumber(info.cardPan);
    const translate = useTranslate('cards');
    return (
        <div className="content frozen-card">
            <i className="icon fa fa-lock"></i>
            <p className="expiry-date">
                {dayjs(info.expiryDate).format('YY/MM')}
            </p>
            <span className="card-number">{cardNumber}</span>
            <p className="name">{info.cardHolderName}</p>
            <p className="title">{translate('cardFrozen')}</p>
            {position === 'center' && (
                <Button onClick={onClick}>
                    {translate('orderReplacement')}
                </Button>
            )}
        </div>
    );
};

export default FrozenCard;
